import { createOpenAI } from '@ai-sdk/openai';
import type { MastraLanguageModel, MastraLegacyLanguageModel } from '@mastra/core/agent';
import type { z } from 'zod';
import type {
  KeywordExtractPrompt,
  QuestionExtractPrompt,
  SummaryPrompt,
  TitleExtractorPrompt,
  TitleCombinePrompt,
} from '../prompts';

export type KeywordExtractArgs = {
  llm?: MastraLegacyLanguageModel | MastraLanguageModel;
  keywords?: number;
  promptTemplate?: KeywordExtractPrompt['template'];
};

export type QuestionAnswerExtractArgs = {
  llm?: MastraLegacyLanguageModel | MastraLanguageModel;
  questions?: number;
  promptTemplate?: QuestionExtractPrompt['template'];
  embeddingOnly?: boolean;
};

export type SummaryExtractArgs = {
  llm?: MastraLegacyLanguageModel | MastraLanguageModel;
  summaries?: string[];
  promptTemplate?: SummaryPrompt['template'];
};

export type TitleExtractorsArgs = {
  llm?: MastraLegacyLanguageModel | MastraLanguageModel;
  nodes?: number;
  nodeTemplate?: TitleExtractorPrompt['template'];
  combineTemplate?: TitleCombinePrompt['template'];
};

export type SchemaExtractArgs<T extends z.ZodType = z.ZodType> = {
  schema: T;
  llm?: MastraLegacyLanguageModel | MastraLanguageModel;
  instructions?: string;
  metadataKey?: string;
};

export const STRIP_REGEX = /(\r\n|\n|\r)/gm;

const openai = createOpenAI({ apiKey: process.env.OPENAI_API_KEY });
export const baseLLM: MastraLegacyLanguageModel | MastraLanguageModel = openai('gpt-4o');
